import { render, staticRenderFns } from "./outstanding.vue?vue&type=template&id=81c3260c&"
import script from "./outstanding.vue?vue&type=script&lang=js&"
export * from "./outstanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports